import { NgTemplateOutlet } from '@angular/common';
import { Component, contentChildren, input, model } from '@angular/core';
import { NgpTabList, NgpTabPanel, NgpTabset } from 'ng-primitives/tabs';
import { TabButtonComponent, TabButtonSize } from './tab-button.component';
import { TabComponent } from './tab.component';

@Component({
  selector: 'joii-tabs',
  imports: [NgpTabset, NgpTabList, NgpTabPanel, NgTemplateOutlet, TabButtonComponent],
  template: `
    <div [(ngpTabsetValue)]="value" ngpTabset>
      <div ngpTabList [attr.data-wrap]="wrap()">
        @for (tab of tabs(); track tab.label()) {
          <joii-tab-button [tab]="tab" [size]="size()" />
        }
      </div>

      @for (tab of tabs(); track tab) {
        <div [ngpTabPanelValue]="tab.value()" ngpTabPanel>
          <ng-container [ngTemplateOutlet]="tab.content()" />
        </div>
      }
    </div>
  `,
  styles: `
    [ngpTabset] {
      width: 100%;
      border-radius: 0.75rem;
      background-color: var(--ngp-background);
      padding: 0.25rem 1rem;
      box-shadow: var(--ngp-button-shadow);
    }

    [ngpTabList] {
      display: flex;
      border-bottom: 1px solid var(--ngp-border);
    }

    [ngpTabList][data-wrap='true'] {
      flex-wrap: wrap;
    }

    [ngpTabPanel] {
      padding: 0.5rem 0;
      outline: none;
    }

    [ngpTabPanel]:not([data-active]) {
      display: none;
    }
  `,
})
export class TabsComponent {
  /**
   * The value of the selected tab.
   */
  readonly value = model<string>();

  /**
   * The size of the tab buttons.
   */
  readonly size = input<TabButtonSize>('md');
  readonly wrap = input<boolean>(true);
  /**
   * The tabs in the group.
   */
  readonly tabs = contentChildren(TabComponent);
}
